/**
 * Format size in bytes to KB, MB, GB etc
 * @param  {Number} bytes
 * @return {String}
 */
const formatFileSize = (bytes) => {
  let b = bytes;
  let u = 0;
  const s = 1024;
  while (b >= s || -b >= s) {
    b /= s;
    u += 1;
  }
  return `${(u ? `${b.toFixed(1)} ` : b)}${' KMGTPEZY'[u]}B`;
};

export default formatFileSize;
